/**
 * FeaturedVideo Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FeaturedVideo template.
 *
 * @namespace FeaturedVideo
 */

import {register} from '../vendor/theme-scripts/theme-sections';
import {videoPlay} from '../features/video-play';
import parallaxHero from '../features/parallax-hero';

const selectors = {
  video: '[data-video-id]',
};

const sections = {};

/**
 * Video section constructor.
 * @param {string} container - selector for the section container DOM element
 */
class Video {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.video = this.container.querySelector(selectors.video);
    this.init();
  }

  init() {
    if (this.video) {
      // Force video autoplay on iOS when Low Power Mode is On
      this.container.addEventListener('touchstart', () => {
        this.video.play();
      });
    }
  }
}

const videoSection = {
  onLoad() {
    sections[this.id] = new Video(this);
  },
};

register('featured-video', [videoSection, videoPlay, parallaxHero, accordions]);
